export const UploadStats = ({ product, files }) => {
    const productFiles = files.filter((f) => f.product === product)

    if (productFiles.length === 0) return null

    const stats = productFiles.reduce(
        (acc, file) => {
            const validCount = file.data.valids.length - 1 // -1 for header row
            const invalidCount = file.data.invalids.length
            const originalCount = file.originalTotalRows

            return {
                totalOriginal: acc.totalOriginal + originalCount,
                totalValid: acc.totalValid + validCount,
                totalInvalid: acc.totalInvalid + invalidCount,
                totalRemoved: acc.totalRemoved + (originalCount - validCount),
                fileCount: acc.fileCount + 1,
            }
        },
        {
            totalOriginal: 0,
            totalValid: 0,
            totalInvalid: 0,
            totalRemoved: 0,
            fileCount: 0,
        },
    )

    const duplicatesRemoved = stats.totalRemoved - stats.totalInvalid

    return (
        <div className="my-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h5 className="font-semibold text-gray-700 mb-3 flex items-center">
                <span className="mr-2">📊</span>
                <span>File Statistics</span>
                {stats.fileCount > 1 && (
                    <span className="ml-2 text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">
                        {stats.fileCount} files
                    </span>
                )}
            </h5>
            <div className="space-y-2 text-sm">
                <StatRow label="Original Leads" value={stats.totalOriginal} />
                <StatRow
                    label="Undeliverable"
                    value={stats.totalInvalid}
                    valueClass="text-red-600"
                    icon="❌"
                />
                {duplicatesRemoved > 0 && (
                    <StatRow
                        label="Duplicates Removed"
                        value={duplicatesRemoved}
                        valueClass="text-orange-600"
                        icon="🗑️"
                    />
                )}
                <StatRow
                    label="Total Removed"
                    value={stats.totalRemoved}
                    valueClass="text-gray-600"
                />
                <StatRow
                    label="Valid Deliverable"
                    value={stats.totalValid}
                    valueClass="text-green-600 font-bold"
                    icon="✅"
                    labelClass="font-semibold"
                />
            </div>
        </div>
    )
}

const StatRow = ({
    label,
    value,
    valueClass = 'text-gray-700',
    icon,
    labelClass = '',
}) => (
    <div className="flex justify-between items-center">
        <span className={`text-gray-600 ${labelClass}`}>
            {icon && <span className="mr-1">{icon}</span>}
            {label}:
        </span>
        <span className={`font-medium ${valueClass}`}>
            {value.toLocaleString()}
        </span>
    </div>
)
